<template lang="html">
  <div>
    <v-bottom-sheet
      v-model="ListForwardDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
      <v-card :style="stylechat" class="pa-2">
        <v-layout row wrap justify-start align-center class="pa-5">
          <v-col
            cols="2"
            justify="start"
            align="start"
            class="pl-0 pr-0 pt-0 pb-0"
            @click="closeDialog"
          >
            <v-icon class="fz-30">mdi-close</v-icon>
          </v-col>
          <v-col
            cols="8"
            justify="center"
            align="center"
            class="pa-0"
          >
            <span class="tab-title">(<b class="">{{ListForwardDetail.length}}</b>) {{$t('ChatSide.forward')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-0 pl-0 pt-0 pb-0"
            >
            <span :class="selectedfriend.length !== 0 ? 'icon-color' : 'icon-color-edit'" @click="sendForward()">{{$t('AnswerQuestion.ok')}}</span>
          </v-col>
        </v-layout>
        <v-divider class="mt-1 mb-2"></v-divider>

        <v-layout v-if="selectedfriend.length !== 0" row wrap justify-start align-start class="pl-5 pr-5 pb-5 mt-0">
          <div class="justify-start align-center scrolling-quickreply pt-3">
            <v-col cols="3" align="center" justify="center" v-for="(item, index) in selectedfriend" :key="index">
              <v-row justify="end" align="end" @click="removeList(item)">
                <v-spacer></v-spacer>
                <v-icon class="color-active" style="padding-right: 12px; position: revert; top: 65px; z-index: 1;">
                  mdi-close-circle
                </v-icon>
              </v-row>
              <v-row justify="center" align="start" class="mt-0">
                <v-avatar size="45">
                  <img v-if="item.picture !== '' && item.profilepicture !== ''" :src="item.type === 'group' ? item.picture : item.profilepicture" alt="alt">
                  <img v-else-if="item.type === 'group'" :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                  <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                </v-avatar>
              </v-row>
              <v-row justify="center" align="center" class="mt-3">
                <p class="text-overflow-badge mb-0">{{item.name}}</p>
              </v-row>
            </v-col>
          </div>
        </v-layout>
        <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-5 mt-0">
          <v-tabs
            color="primary"
            slider-color="primary"
            centered
          >
          <v-tabs-slider></v-tabs-slider>
            <v-tab>
              <b style="text-transform: none;">{{$t('LeftSide.header.friend')}}</b>
            </v-tab>

            <v-tab>
              <b style="text-transform: none;">{{$t('LeftSide.friend.group')}}</b>
            </v-tab>

            <v-tab-item>
              <v-card flat>
                <v-layout row wrap justify-start align-center class="pt-7 pl-5 pr-5 pb-3">
                  <v-text-field
                    ref="search"
                    v-model="search"
                    :placeholder="$t('LeftSide.addFiend.searching')"
                    prepend-inner-icon="mdi-magnify"
                    solo
                    dense
                    hide-details
                    clearable
                  ></v-text-field>
                </v-layout>
                <v-list class="list-overflow" v-if="FilterListFriend.length === 0">
                  <v-icon class="icon-color" style="justify-content: center; display: flex; margin-top: 50px; font-size: 50px; overflow: hidden;">fa-solid fa-list</v-icon>
                  <h4 class="mt-5" style="justify-content: center; display: flex;">{{$t('LeftSide.noDataSearching')}}</h4>
                </v-list>
                <v-list v-else :class="selectedfriend.length !== 0 ? 'list-overflow-select' : 'list-overflow'">
                  <v-subheader v-if="FilterListFriend.length !== 0">{{$t('LeftSide.header.friend')}} ({{FilterListFriend.length}})</v-subheader>
                  <v-radio-group v-model="contact_select" column class="mt-1">
                    <template v-for="(item, index) in FilterListFriend">
                      <v-list-item
                        :key="item.tokenuser"
                      >
                        <template v-slot:default="{ active, toggle }">
                          <v-list-item-avatar>
                            <v-img v-if="item.profilepicture" :src="item.profilepicture" class="img-position"></v-img>
                            <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                            <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                            <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name" class="text-overflow">
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action class="pb-2">
                            <v-checkbox v-model="selectedfriend" :value="item"></v-checkbox>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                      <v-divider
                        v-if="index < FilterListFriend.length - 1"
                        :key="index"
                      ></v-divider>
                    </template>
                  </v-radio-group>
                </v-list>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <v-layout row wrap justify-start align-center class="pt-7 pl-5 pr-5 pb-3">
                  <v-text-field
                    ref="search"
                    v-model="search"
                    :placeholder="$t('Dialog.forward.searchgroup')"
                    prepend-inner-icon="mdi-magnify"
                    solo
                    dense
                    hide-details
                    clearable
                  ></v-text-field>
                </v-layout>
                <v-list class="list-overflow" v-if="FilterListgroup.length === 0">
                  <v-icon class="icon-color" style="justify-content: center; display: flex; margin-top: 50px; font-size: 50px; overflow: hidden;">fa-solid fa-list</v-icon>
                  <h4 class="mt-5" style="justify-content: center; display: flex;">{{$t('LeftSide.noDataSearching')}}</h4>
                </v-list>
                <v-list v-else :class="selectedfriend.length !== 0 ? 'list-overflow-select' : 'list-overflow'">
                  <v-subheader v-if="FilterListgroup.length !== 0">{{$t('LeftSide.friend.group')}} ({{FilterListgroup.length}})</v-subheader>
                  <v-radio-group v-model="contact_select" column class="mt-1">
                    <template v-for="(item, index) in FilterListgroup">
                      <v-list-item
                        :key="item.tokenroom"
                      >
                        <template v-slot:default="{ active, toggle }">
                          <v-list-item-avatar>
                            <v-img v-if="item.picture" :src="item.picture" class="img-position"></v-img>
                            <img v-else :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name" class="text-overflow">
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action class="pb-2">
                            <v-checkbox v-model="selectedfriend" :value="item"></v-checkbox>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                      <v-divider
                        v-if="index < FilterListgroup.length - 1"
                        :key="index"
                      ></v-divider>
                    </template>
                  </v-radio-group>
                </v-list>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-layout>
      </v-card>
    </v-bottom-sheet>
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
  </div>
</template>

<script>
import WarningDialog from '@/components/Alert/Warning'
import ErrorDialog from '@/components/Alert/Error'
var _ = require('lodash')
export default {
  props: {
    ListForwardDialog: Boolean,
    ListForwardDetail: Array
  },
  data() {
    return {
      tab: 'tab-1',
      selectedfriend: [],
      contact_select: '',
      publicPath: process.env.VUE_APP_BASE_PATH,
      selected: [],
      FriendList: [],
      GroupList: [],
      ErrorDialogDetail: {},
      ErrorDialog: false,
      WarningDialogDetail: {},
      WarningDialog: false,
      data_user: {},
      edit_member: false,
      member_active: [],
      member_pending: [],
      progress: false,
      search: '',
      stylechat: {
        "--ListForward-HeaderColor": "white",
        "--ListForward-TabBackground": "white",
        "--ListForward-Icon": "gray",
        "--ListForward-IconActive": "#2662ae",
        "--ListForward-Background": "white",
        "--ListForward-FontSize": "18px",
        "--ListForward-FontSize-Title": "24px",
        "--ListForward-FontColor": "back",
        "--ListForward-FontSize-Status": "16px",
        "--ListForward-FontColor-Status": "grey",
        "--ListForward-Background-Input": "#E2E1E3",
        "--ListForward-Color-Button": "#EFF2FE",
        "--ListForward-FontColor-Button": "#2662ae",
        "--ListForward-FontColor-Block-Button": "#cb1002",
        "--ListForward-FontColor-Dis-Button": "#e2e1e3",
        "--ListForward-Btn-Confirm-Background": "#2662ae",
        "--ListForward-Btn-Confirm-Color": "white",
        "--ListForward-Btn-Confirm-FontSize": "18px",
        "--ListForward-Btn-Cancel-Background": "white",
        "--ListForward-Btn-Cancel-Color": "#2662ae",
        "--ListForward-Btn-Cancel-FontSize": "18px",
        "--ListForward-Btn-Leave-Background": "white",
        "--ListForward-Btn-Leave-Color": "#ff5252",
        "--ListForward-Btn-Leave-FontSize": "18px"
      },
    }
  },
  components: {
    WarningDialog,
    ErrorDialog
  },
  computed: {
    FilterListFriend () {
      if (this.search !== '' && this.search !== null) {
        return this.FriendList.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.FriendList
      }
    },
    FilterListgroup () {
      if (this.search !== '' && this.search !== null) {
        return this.GroupList.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.GroupList
      }
    },
  },
  watch: {
    ListForwardDialog () {
      if (this.ListForwardDialog) {
        // console.log(this.ListForwardDetail)
        this.getListFriend()
        this.getListGroup()
      }
    },
    selectedfriend () {
      if (this.selectedfriend.length > 5) {
        this.ErrorDialogDetail = {
          title: '',
          text: this.$t('Alert.Fail.forward.maxChatRoom')
        }
        this.ErrorDialog = true
        _.pullAt(this.selectedfriend, [5])
      }
    },
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
  },
  methods: {
    removeList (item) {
      this.selectedfriend.splice(this.selectedfriend.indexOf(item), 1)
    },
    sendForward () {
      if (this.selectedfriend.length !== '') {
        // console.log(_.map(this.selectedfriend, 'tokenroom'))
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_message + `/forward_file_message`, {
          list_tokenroom: _.map(this.selectedfriend, 'tokenroom'),
          list_tokenmessage: this.ListForwardDetail,
          tokenuser: this.data_user.tokenuser,
        }).then((response) => {
          // console.log(response.data)
          if (response.data['status'] === 'success') {
            this.progress = false
            this.FriendList = []
            this.selectedfriend = []
            this.$emit('emitComponents', {
              name: 'ListForward',
              value: false
            })
          }
        }).catch(err => {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    },
    getListFriend () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_GO + '/v1/get-list-friend', {
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          if (response.data.status === 'success') {
            // this.progress = false
            this.FriendList = response.data['list_friend']
          }
      }).catch(err => {
        console.log(err)
        this.selected = []
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    getListGroup () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_GO + '/v1/get-list-group', {
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          if (response.data.status === 'success') {
            this.progress = false
            this.GroupList = response.data['list_active_group']
          }
      }).catch(err => {
        console.log(err)
        this.selected = []
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    closeAlertDialog (data) {
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      }
    },
    emitWarning (item) {
      this.WarningDialog = false
      if (item.type === 'kickgroup') {
        this.kickGroup(item)
      } else if (item.type === 'cancelinvite') {
        this.cancelInvite(item)
      }
    },
    closeDialog() {
      this.selected = []
      this.search = ''
      this.member_active = []
      this.member_pending = []
      this.FriendList = []
      this.selectedfriend = []
      this.$emit('closeComponents', {
        name: 'ListForward',
        value: false
      })
    },
  },
}
</script>

<style lang="css" scoped>
.color-active {
  color: var(--ListForward-IconActive) !important;
}
.scrolling-quickreply {
  /* height: 42px; */
  padding: 6px;
  background: var(--ListForward-Background) !important;
  width: 100vw;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}

.scrolling-quickreply::-webkit-scrollbar-thumb {
    background-color: #b6b6b6 !important;
    color: #b6b6b6 !important;
    border-radius: 10px;
    background-clip: padding-box;
}

.scrolling-quickreply::-webkit-scrollbar {
    height: 6px !important;
}
.checkbox-color {
  color: var(--ListForward-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 150px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 260px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--ListForward-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--ListForward-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--ListForward-Icon) !important;
}
.icon-color {
  color: var(--ListForward-IconActive) !important;
}
.btn-confirm {
  background-color: var(--ListForward-Btn-Confirm-Background) !important;
  color: var(--ListForward-Btn-Confirm-Color) !important;
  font-size: var(--ListForward-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--ListForward-Btn-Cancel-Background) !important;
  color: var(--ListForward-Btn-Cancel-Color) !important;
  font-size: var(--ListForward-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--ListForward-Btn-Leave-Background) !important;
  color: var(--ListForward-Btn-Leave-Color) !important;
  font-size: var(--ListForward-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--ListForward-Background) !important;
}
.fz-30 {
  font-size: 30px;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--ListForward-FontSize-Title) !important;
  color: var(--ListForward-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--ListForward-FontColor) !important;
  font-size: var(--ListForward-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--ListForward-FontColor-Status) !important;
  font-size: var(--ListForward-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.text-overflow-badge {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 15vw;
}
</style>
